module.exports = __webpack_public_path__ + "img/PSD.00bb275c.png";